module.exports = __webpack_public_path__ + "static/media/cover_pic.a08c80ca.png";